import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import useInheritParams from 'hooks/useInheritParams';
import styles from './PageLinks.module.scss';

type linkProps = {
  path: string;
  label: string;
  exact: boolean;
};

const links: linkProps[] = [
  {
    path: '/set',
    label: 'おすすめプラン',
    exact: false,
  },
  {
    path: '/works',
    label: '制作事例',
    exact: false,
  },
  {
    path: '/contents',
    label: 'コンテンツ一覧',
    exact: false,
  },
  {
    path: '/',
    label: 'デザイン',
    exact: true,
  },
];

type PageLinksProps = {
  setPosition: string;
  onClick?: () => void;
};

const PageLinks: React.FC<PageLinksProps> = ({ setPosition, onClick }) => {
  const designsRouteMatch = useRouteMatch('/designs/:business?');
  const { inheritParams } = useInheritParams();

  return (
    <ul className={styles[setPosition]}>
      {links.map((link) => (
        <li key={link.path} className={styles[`${setPosition}__item`]}>
          <NavLink
            to={{
              pathname: link.path,
              search: inheritParams,
            }}
            exact={link.exact}
            className={styles[`${setPosition}__link`]}
            activeClassName={styles[`${setPosition}__link_active`]}
            isActive={(match) => match !== null || (designsRouteMatch !== null && link.path === '/')}
            onClick={onClick}
          >
            {link.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

PageLinks.defaultProps = {
  onClick: undefined,
};

export default PageLinks;
